import { createContext } from 'react';

import { Customizations } from './types';

const CustomizationsContext = createContext<Customizations | undefined>(undefined);

export { CustomizationsContext };
